const lang_change = (lang) => ({ type: "LANGUAGE", payload: lang });

const add_system = (data) => ({ type: "NEWSYSTEM", payload: data });
const reset_system = (remove) => ({type: "RESETSYSTEM" , payload: remove})
const add_fact_step1 = (data) => ({type:"ADDFACTSTEP1" , payload:data})
const add_fact_step3 = (data) => ({type:"ADDFACTSTEP3" , payload:data})

const in_fact = (bool) => ({type:"INFACT" , payload : bool})
const add_facts_id = (id) => ({type:"ADDFACTSID" , payload : id})

const tickets_id = (id) => ({type:"TICKETSID" , payload:id})

const plant_id = (plantID) => ({type:"PLANTID" , payload:plantID})

const user_account_level = (level) => ({type:"USERACCOUNTLEVEL" , payload:level})
const user_role = (role) => ({type:"USERROLE" , payload:role})

const logged_in = (bool) => ({type:"LOGGEDIN", payload:bool})
const logged_out = () => ({type:"LOGGEDOUT"})
// //Profile Actions Start
// const last_name1 = (e) => ({ type: "LAST_NAME", payload: e });
// const email1 = (e) => ({ type: "EMAIL", payload: e });
// const name1 = (e) => ({ type: "NAME", payload: e });
// const coName1 = (e) => ({ type: "CONAME", payload: e });
// const phone1 = (e) => ({ type: "PHONE", payload: e });
// const website1 = (e) => ({ type: "WEBSITE", payload: e });
// const country1 = (e) => ({ type: "COUNTRY", payload: e });
// const city1 = (e) => ({ type: "CITY", payload: e });
// const code_p1 = (e) => ({ type: "CODE_P", payload: e});
// const addres1 = (e) => ({ type: "ADDRES", payload: e });
// const code_m1 = (e) => ({ type: "CODE_M", payload: e });
// // Profile Actions End :)

export {
  in_fact,
  add_facts_id,
  lang_change,
  add_system,
  reset_system,
  add_fact_step1,
  add_fact_step3,
  tickets_id,
  user_role,
  user_account_level,
  plant_id,
  logged_in,
  logged_out
  
  //       last_name1,
  //   email1,
  //   name1,
  //   code_m1,
  //   addres1,
  //   code_p1,
  //   website1,
  //   country1,
  //   city1,
  //   phone1,
  //   coName1
};
